import * as React from 'react';
import * as ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
// tslint:disable-next-line:ordered-imports
import App from './app/App';
import './index.css';
// tslint:disable-next-line:ordered-imports
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'font-awesome/css/font-awesome.min.css';

/* tslint:disable */

import ActiveDirectoryAuthenticator from './adal/ActiveDirectoryAuthenticator';
import AdalConfigProvider from './adal/AdalConfigProvider';

var ADA = new ActiveDirectoryAuthenticator(new AdalConfigProvider());

ADA.handleCallback();

if (!ADA.isAuthenticated) {
    ADA.login();
} else {
    ReactDOM.render(
        <App token={ADA.accessToken} userName={ADA.userInfo.profile.name} />,
        document.getElementById('root') as HTMLElement
    );
    registerServiceWorker();
}

// ReactDOM.render(
//   <App />,
//   document.getElementById('root') as HTMLElement
// );
// registerServiceWorker();

// function getStrings(str: any) {
//   var exp = str.split(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/);
//   console.log(exp);
//   return exp[1]+exp[3];
// }



// WEBPACK FOOTER //
// ./src/index.tsx